import React from 'react';
import classNames from 'classnames';
import { formatCurrency, QuestionTypeViewPropTypes } from '../../utils';

const Calculated = (props) => {
  const { className, question, isQA = false, value: result = {} } = props;

  const { value = 0, loading = false } = result;

  const attributes = question?.attributes || {};

  const shouldShow = isQA || !attributes.hidden;

  const formatAnswer = (amount) => {
    if (attributes.format === 'percent') {
      return `${amount}%`;
    } else if (attributes.format === 'currency') {
      return formatCurrency(amount);
    }
    return amount;
  };

  const classes = classNames(className, {
    calculatedInput: true,
    'calculatedInput--loading': loading,
  });

  return (
    shouldShow && (
      <div className={classes}>
        <span>{formatAnswer(value)}</span>
      </div>
    )
  );
};

Calculated.propTypes = {
  ...QuestionTypeViewPropTypes,
};

export default Calculated;
